var _style, _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViscosity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448.4 39.7",
    style: {
      enableBackground: "new 0 0 448.4 39.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{clip-path:url(#SVGID_00000178193523565443720910000018407359880693248652_);}\n\t.st3{font-family:'LustDisplay-Regular';}\n\t.st4{font-size:226.1338px;}\n\t.st5{letter-spacing:54;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000095301217035046649580000012906034989187720066_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -1274.3,
    y: -1479.4,
    width: 3000,
    height: 3000
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006682325399816516550000017281697296335580824_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006682325399816516550000017281697296335580824_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 4000,
    height: 4000,
    xlinkHref: "1777FFA3.jpeg",
    transform: "matrix(0.75 0 0 0.75 -1274.3301 -1479.421)"
  }))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000123415969984048966740000009237175630921993879_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -691.1065 97.9891)",
    className: "st1 st3 st4 st5"
  }, "VISCOSITY"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,0.4h16.2v0.2c-4.6,0-7.8,4.5-12.4,13.7l-12.8,26L9.4,11C5.9,3.8,4.2,0.7,0,0.7V0.4h23.4v0.2 c-5.8,0-4.8,4.4-2.1,10.2l7.9,17L36,14.2c3.6-7.3,3.2-13.6-3.5-13.6V0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8,39.3V39c5.8,0,5.8-3.2,5.8-9.7V10.4c0-6.7,0-9.7-5.8-9.7V0.4h23v0.2c-5.8,0-5.8,3-5.8,9.7v18.9c0,6.5,0,9.7,5.8,9.7 v0.2H63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9,38.4l-4.1,1.2l-0.9-16.1h0.2c0.9,7.4,4.7,15.9,14.7,15.9c5.1,0,9-1.9,9-6.1c0-9.3-24.2-8.5-24.2-21.9 C101.7,4,109,0,117.7,0c2.6,0,6.8,0.7,8.8,1.3l4.2-1.2l0.7,13.6h-0.2c-0.7-6.8-4.6-13.5-13.5-13.5c-4.6,0-7.5,2.3-7.5,5.6 c0,8.8,24.2,7.4,24.2,21.2c0,7.8-8.2,12.6-17.6,12.6C112.9,39.7,109,39,106.9,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.1,19.9C150.1,8.2,160.4,0,173,0c3.5,0,7.2,0.9,8.5,1.3l4.2-1.2l0.9,15.5h-0.2c-0.6-6.4-4.2-15.3-13.4-15.3 s-10.3,11.2-10.3,19.6s1.1,19.6,10.3,19.6s12.7-8.9,13.4-15.3h0.2l-0.9,15.5l-4.2-1.2c-1.3,0.4-5.1,1.3-8.5,1.3 C160.4,39.7,150.1,31.5,150.1,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,19.9C204,7.2,213.5,0,225.1,0s21.1,7.2,21.1,19.9s-9.5,19.9-21.1,19.9S204,32.5,204,19.9z M233.6,19.9 c0-8.5-0.6-19.6-8.5-19.6c-7.9,0-8.5,11.1-8.5,19.6s0.6,19.6,8.5,19.6C233,39.4,233.6,28.3,233.6,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,38.4l-4.1,1.2L263,23.5h0.2c0.9,7.4,4.7,15.9,14.7,15.9c5.1,0,9-1.9,9-6.1c0-9.3-24.2-8.5-24.2-21.9 c0-7.5,7.4-11.5,16-11.5c2.6,0,6.8,0.7,8.8,1.3l4.2-1.2l0.7,13.6h-0.2c-0.7-6.8-4.6-13.5-13.5-13.5c-4.6,0-7.5,2.3-7.5,5.6 c0,8.8,24.2,7.4,24.2,21.2c0,7.8-8.2,12.6-17.6,12.6C274,39.7,270.1,39,268,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,39.3V39c5.8,0,5.8-3.2,5.8-9.7V10.4c0-6.7,0-9.7-5.8-9.7V0.4h22.9v0.2c-5.8,0-5.8,3-5.8,9.7v18.9 c0,6.5,0,9.7,5.8,9.7v0.2H309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.4,39.3V39c6.4,0,6.7-3.2,6.7-9.7V0.7c-9.1,0-13.1,5.5-14.1,13.9h-0.2l1.5-14.2h37.1l1.5,14.2h-0.2 c-1-8.4-5-13.9-14.1-13.9v28.6c0,6.5,0.3,9.7,6.7,9.7v0.2H354.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.5,0.4h15.9v0.2c-5.9,0-10.3,5.9-14.7,14.2l-3.6,6.9v7.5c0,6.4,0,9.7,5.8,9.7v0.2h-23V39c5.8,0,5.8-3.3,5.8-9.7v-5.8 l-9.7-16c-2.8-4.7-4.3-6.8-7.9-6.8V0.5h23.2v0.2c-6.7,0-4.6,3.7-2.8,6.8l8.2,13.9l3.5-6.6c4.4-8.3,7.1-14.2-0.8-14.2L432.5,0.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViscosity);
export default __webpack_public_path__ + "static/media/VISCOSITY.1f218c5fec748748f254c9c893f38a13.svg";
export { ForwardRef as ReactComponent };